import { Phone, X, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";

const HELPLINES = [
    { name: "National Emergency", number: "112", desc: "All-in-one emergency support" },
    { name: "Vandrevala Foundation", number: "1860-266-2345", desc: "Mental health crisis & counseling" },
    { name: "iCall (TISS)", number: "9152987821", desc: "Psychosocial support (Mon-Sat)" },
    { name: "AASRA", number: "9820466726", desc: "24x7 Suicide Prevention" },
    { name: "Sneha India", number: "044-24640050", desc: "Emotional support & suicide prevention" },
];

export default function HelplineModal({ onClose }) {
    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-red-100 dark:border-red-900 overflow-hidden"
            >
                <div className="bg-red-50 dark:bg-red-900/20 p-6 border-b border-red-100 dark:border-red-900/50">
                    <div className="flex justify-between items-start">
                        <div>
                            <h2 className="text-xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
                                <Phone className="w-5 h-5 text-red-500 fill-current" />
                                Emergency Help
                            </h2>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                You are not alone. Help is available.
                            </p>
                        </div>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>

                <div className="p-4 max-h-[60vh] overflow-y-auto">
                    <div className="space-y-3">
                        {HELPLINES.map((line) => (
                            <a
                                key={line.name}
                                href={`tel:${line.number}`}
                                className="flex items-center justify-between p-3 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/50 border border-gray-100 dark:border-gray-700 transition group"
                            >
                                <div>
                                    <div className="font-semibold text-gray-800 dark:text-gray-200">{line.name}</div>
                                    <div className="text-xs text-gray-500 dark:text-gray-400">{line.desc}</div>
                                </div>
                                <div className="flex items-center gap-2 text-brand-blue font-bold bg-blue-50 dark:bg-blue-900/30 px-3 py-1.5 rounded-lg group-hover:bg-brand-blue group-hover:text-white transition">
                                    <span className="text-sm">{line.number}</span>
                                </div>
                            </a>
                        ))}
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700 text-center">
                        <a
                            href="https://findahelpline.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="text-xs text-gray-400 hover:text-brand-blue hover:underline flex items-center justify-center gap-1"
                        >
                            Find more international helplines <ExternalLink className="w-3 h-3" />
                        </a>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
